import React, { useState } from "react";

import BroadcastCard from "./BroadcastCard";
import EditOVPBroadcastModal from "./EditOVPBroadcastModal";
import FastScheduleTag from "../../tag/FastScheduleTag";
import Tag, { SIZES_TAG } from "../../tag/Tag";

import type { JSX } from "react";

import type {
  OVPBroadcast,
  ScheduleBroadcast,
} from "../../../api/FastAPI.types";

interface ISchedule {
  id: string;
  broadcasts: (ScheduleBroadcast | OVPBroadcast)[];
  framerate: number;
  setActiveBroadcastId: (broadcastId: string) => void;
  setActiveScheduleId: (scheduleId: string) => void;
  activeBroadcastId: string | null;
}

function Schedule({
  id,
  broadcasts,
  framerate,
  setActiveBroadcastId,
  setActiveScheduleId,
  activeBroadcastId,
}: ISchedule): JSX.Element {
  const [editingBroadcast, setEditingBroadcast] = useState<OVPBroadcast | null>(
    null,
  );

  const handleClick = (broadcastId: string, scheduleId: string): void => {
    setActiveBroadcastId(broadcastId);
    setActiveScheduleId(scheduleId);
  };

  return (
    <div className="flex flex-col">
      <div className="mb-5 flex items-center gap-[0.46875rem]">
        <FastScheduleTag scheduleId={id} size={SIZES_TAG.SMALL} />
        <span>-</span>
        <Tag size={SIZES_TAG.SMALL}>{framerate} FPS</Tag>
      </div>
      {Boolean(broadcasts.length) && (
        <div className="mb-5 flex flex-col gap-2.5">
          {broadcasts.map((broadcast) => (
            <BroadcastCard
              key={broadcast.uuid}
              distributionFormat={broadcast.distribution_format}
              id={broadcast.uuid}
              isActive={activeBroadcastId === broadcast.uuid}
              logoUrl={broadcast.broadcaster_logo_url}
              name={broadcast.name}
              onClick={(broadcastId): void => handleClick(broadcastId, id)}
              onEditClick={
                broadcast.type === "ovp"
                  ? (): void => setEditingBroadcast(broadcast)
                  : undefined
              }
            />
          ))}
        </div>
      )}
      {editingBroadcast ? (
        <EditOVPBroadcastModal
          isOpen
          broadcast={editingBroadcast}
          onClose={(): void => setEditingBroadcast(null)}
        />
      ) : null}
    </div>
  );
}

export default Schedule;
